<template>
    <div class="bg-color">
        <Navbar />
        <Header :category="'press'" :bannerTitle="bannerTitle" :breadCrumb="breadCrumb" />
        <ReportBody :title="bannerTitle" />
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>
    import Navbar from 'components/DefaultHome/KECC/Common/NavbarStyle'
    import Header from 'components/DefaultHome/KECC/Common/Header'
    import ReportBody from './ReportBody'
    import FooterTop from 'components/DefaultHome/KECC/Common/FooterTop?v=1.0'
    import FooterBottom from 'components/DefaultHome/KECC/Common/BacktopButton'

    export default {
        name: 'VideoMain',
        metaInfo() {
            return {
                title: this.$t("navbar.menu_3_3"),
            }
        },
        components: {
            Navbar,
            Header,
            ReportBody,
            FooterTop,
            FooterBottom,
        },
        data() {
            return {
                bannerTitle: "流量報告",
                breadCrumb: [{
                    name: "流量報告"
                }]
            }
        },
    }
</script>

<style scoped>
    .bg-color {
        background-color: #eff4f5;
    }
</style>